import { Grid2, IconButton, Switch, Tooltip, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { FETCH_CHAT_SETTINGS } from "@chat/graphql/queries/fetchChatSettings";
import { Query, Mutation } from "@/app/graphql/codegen";
import { EDIT_CHAT_SETTINGS } from "@company/graphql/mutations/updateChatSettings";
import { FETCH_CONTEXT_SELECTION_FOR_CHAT } from "@chat/graphql/queries/fetchContextSelectionForChat";
import { icon } from "@/app/style/icons";

const GptOnlyToggle = () => {
    const { id: chatId } = useParams();

    const { data, loading } = useQuery<Pick<Query, "chat">>(FETCH_CHAT_SETTINGS, {
        variables: { id: chatId || "" },
        skip: !chatId,
    });

    const { data: contextData } = useQuery<Pick<Query, "contextForChat">>(FETCH_CONTEXT_SELECTION_FOR_CHAT, {
        variables: { chatId: chatId || "" },
        skip: !chatId,
    });

    const [editSettings] = useMutation<Pick<Mutation, "editChatSettings">, { id: string; gptOnlyEnabled?: boolean; graphEnabled?: boolean }>(EDIT_CHAT_SETTINGS);

    const isGptOnlyEnabled = (contextData?.contextForChat as any)?.gptOnlyEnabled || (data?.chat as any)?.gptOnlyEnabled || ((data?.chat?.settings as any)?.gptOnlyEnabled) || false;

    const toggleGptOnly = async () => {
        if (!chatId) return;

        await editSettings({
            variables: {
                id: chatId,
                gptOnlyEnabled: !isGptOnlyEnabled,
                // Enforce exclusivity: when GPT-only ON, graph must be OFF
                graphEnabled: isGptOnlyEnabled ? undefined : false,
            },
            refetchQueries: [
                { query: FETCH_CHAT_SETTINGS, variables: { id: chatId } },
                { query: FETCH_CONTEXT_SELECTION_FOR_CHAT, variables: { chatId } },
            ],
        });
    };

    return (
        <Grid2 container size={12} alignItems="center" justifyContent="space-between">
            <Grid2 container alignItems={"center"} size="auto" spacing={0.5}>
                <Grid2>
                    <Typography>Standard KI Anfrage</Typography>
                </Grid2>

                <Grid2>
                    <Tooltip
                        title={
                            "Standard KI Anfrage sendet Anfragen mit einem minimalen System-Prompt und ohne Dokument-Kontext. Wenn der Unternehmenskontext aktiviert ist, wird er dennoch kurz hinzugefügt."
                        }
                    >
                        <IconButton size={"small"} color={"default"} sx={{ opacity: 1 }}>
                            <icon.info sx={{ color: "semantic.icon.informative" }} />
                        </IconButton>
                    </Tooltip>
                </Grid2>
            </Grid2>

            <Grid2>
                <Switch
                    checked={isGptOnlyEnabled}
                    onChange={toggleGptOnly}
                    disabled={loading}
                    sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#707070", // darker gray for the circle // TODO: use semantic color
                            "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#505050", // color of the track when switch on (fallback to gray) // TODO: use semantic color
                        },
                    }}
                />
            </Grid2>
        </Grid2>
    );
};

export default GptOnlyToggle;

